/* lua.js generated code 0.3.0 */

HeadImageLoader = xClass("HeadImageLoader")
HeadImageLoader.defaultHead = "https://ff.happyelements.com/cdn/app/1001/avatar/7.png"
HeadImageLoader.pushURLStack = function () {
    let self = this
    if (!self.stack) {
        self.stack = table()
    }
    table.insert(self.stack, table())
}
HeadImageLoader.popURLStack = function () {
    let self = this
    if (self.stack) {
        if ($len(self.stack) > 0) {
            pcall(function () {
                for (let k = 1, v = self.stack[$len(self.stack)][1]; v; k++, v = self.stack[$len(self.stack)][k]) {
                    if (he.HeFileUtils.exists(v)) {
                        let value = he.HeFileUtils.removeFile(v)
                        if (value) { } else {
                            // print("pop out failed", tostring(v))
                        }
                    } else {
                        // print("pop out failed invalid path", tostring(v))
                    }
                }
            })
            table.remove(self.stack, $len(self.stack))
        }
    }
}
HeadImageLoader.loadImage = function (node, headImageUrl, finishCallback, noneMask, headType) {
    if (node && node.nodeExist == false){
        return;
    }
    let self = this
    node.nodeExist = true
    let is_load = false
    headImageUrl = headImageUrl || HeadImageLoader.defaultHead
    if (headImageUrl.indexOf("https://sff.happyelements.com/cdn/app/1001/avatar/") == 0) {
        headImageUrl = "head://" + headImageUrl.substr("https://sff.happyelements.com/cdn/app/1001/".length)
    } else if (headImageUrl.indexOf("https://ff.happyelements.com/cdn/app/1001/avatar/") == 0) {
        headImageUrl = "head://" + headImageUrl.substr("https://ff.happyelements.com/cdn/app/1001/".length)
    }
    if(headImageUrl.indexOf){
        if ( headImageUrl.indexOf("http://") != -1 || headImageUrl.indexOf("https://") != -1) {
            is_load = true
            HeadImageLoader.loadRemoteCustomImage(node, headImageUrl, finishCallback, noneMask, headType)
        } else if (headImageUrl.indexOf("head://") != -1) {
            is_load = true
            headImageUrl = headImageUrl.substr(7) // "head://".length
            HeadImageLoader.loadLocalCustomImage(node, headImageUrl, finishCallback, noneMask)
        }
    }
    if(!is_load){
        HeadImageLoader.loadLocalImage(node, headImageUrl, finishCallback, noneMask)
    }
}
function lstrip(str, content) {
    if (!str || type(str) !== "string") {
        return ""
    }
    if (str.length === 0) {
        return str
    }
    var $limit3 = str.length
    for (var i = 1; i <= $limit3; i += 1) {
        var xchar = str.sub(i, i)
        if (xchar !== content) {
            // WARN: maybe multi result
            return str.sub(i)
        }
    }
    return ""
}
function rstrip(str, content) {
    if (!str || type(str) !== "string") {
        return ""
    }
    if (str.length === 0) {
        return str
    }
    var $var6 = str.length
    for (var i = $var6; i >= 1; i += -1) {
        var xchar = str.sub(i, i)
        if (xchar !== content) {
            // WARN: maybe multi result
            return str.sub(1, i)
        }
    }
    return ""
}
const HuaweiDomain = [
    "hicloud.com"
]
HeadImageLoader.loadRemoteCustomImage = function (node, headImageUrl, finishCallback, noneMask, headType) {
    let self = this
    if (finishCallback) {
        setTimeOut(function () {
            if (finishCallback) {
                finishCallback(-1)
                finishCallback = null
            }
        }, 3)
    }
    
    console.log("huawei requesthead origin", headImageUrl)
    if (getCurrentPlatform() == XcloverPlatform.huawei){
        for (let domain in HuaweiDomain){
            if (headImageUrl.indexOf(domain) != -1){
                let md5 = require("clover/utils/md5")
                // let host = require("./host")
                let querystring = HTTP_HOST_QUERY ? HTTP_HOST_QUERY + "&" : ""
                headImageUrl = HTTP_HOST + "/getAvatar?"+ querystring +"avatar=" + HeDisplayUtil.urlEncode( headImageUrl) + "&sign=" + md5(headImageUrl + "&e2ef5ef8744db446dcc9b5a53ca88b3c")
                break
            }
        }
    }
    console.log("huawei requesthead final", headImageUrl)

    let delHeadTypes = ["rank"];//, "buildShip", "goldElysium", "qualify", "stickerBattle"

    let clearRefnum = function (err) {
        node = null;
        if(err) {
            console.error("clearRefnum-err", err);
            return;
        }
        let temp = cc.loader.getRes(headImageUrl);
        if(!temp){
            return
        }
        if(delHeadTypes.indexOf(headType) == -1) return

        let cacheRefnum = cc.loader.cacheRefnum[headImageUrl];
  
        if(cacheRefnum <= 1) {
            //由于release和_loadResIterator时对refnum的处理不同，所以需要特殊处理
            let ext = cc.path.extname(headImageUrl)
            if (ext === '.png' || ext === '.pvr' || ext === '.jpg' || ext === '.jpeg') {
                ResManager.release([headImageUrl])
            }else{
                temp.refnum--;
                if (!temp.refnum || temp.refnum <= 0) {
                    cc.textureCache.removeTextureForKey(headImageUrl);
                }
            }
        } else {
            //如果同时加载一张图片，则cacheRefnum会+1
            // cacheRefnum--;
            // cc.loader.cacheRefnum[headImageUrl] = cacheRefnum;
        }
    }

    function loadThirdPartyResCallback(err) {
        if (!node.nodeExist ) {
            clearRefnum(err);
            return
        }
        /**
         * 1.资源在node删除之后才加载完成，这时候会导致资源计数未-1.且node无法被销毁
         * 无法在replaceImage时知道node是否已经onCleanup。需要再使用者所在的节点removeAllChildren、removeFromParent，让replaceImage时node.getParent() == null
         * 
         * 2.同时加载一个url的资源，cacheRefnum计数 > 1
         * 如果cacheRefnum计数大约1，则先减除其计数
         */
        let data = err? null: cc.loader.getRes(headImageUrl);
        if (data) {
            var sprite = HeadImageLoader.procCustomImage(headImageUrl, noneMask)
            if (sprite) {
                const isOk = HeadImageLoader.replaceImage(node, sprite)
                if(isOk) {
                    sprite.onCleanup = function() {
                        clearRefnum(err);
                    }
                }else{
                    sprite.removeFromParent(true);
                    clearRefnum(err);
                }
            }else {
            }
        }
        if (finishCallback) {
            finishCallback()
            finishCallback = null
        }
    }

    cc.loader.load({src: headImageUrl, type: 'png', isHead: true}, loadThirdPartyResCallback); 
}
HeadImageLoader.loadLocalCustomImage = function (node, headImageUrl, finishCallback, noneMask) {
    var sprite = HeadImageLoader.procCustomImage(headImageUrl, noneMask)
    if (sprite) {
        HeadImageLoader.replaceImage(node, sprite)
    }
    if (finishCallback) {
        finishCallback()
        finishCallback = null
    }
}
HeadImageLoader.loadLocalImage = function (node, headImageUrl, finishCallback, noneMask) {
    var headImage = tonumber(headImageUrl)
    if (headImage == null || isNaN(headImage ))  {
        headImage = 0
    }
    if (headImage < 0) {
        headImage = 0
    }
    if (headImage > 10) {
        headImage = 10
    }
    FrameLoader.loadImageWithPlist("materials/head_images.plist")
    var sprite = cc.Sprite.createWithSpriteFrameName("h" + tostring(headImage))
    if (sprite) {
        HeadImageLoader.replaceImage(node, sprite)
    }
    if (finishCallback) {
        finishCallback()
        finishCallback = null
    }
}
HeadImageLoader.procCustomImage = function (path, noneMask) {
    var head_len = 100
    var sprite = cc.Sprite.create(path)
    if (sprite) {
        let size = sprite.getContentSize()
        sprite.setScaleX(head_len / (size.width === 0 ? 100 : size.width))
        sprite.setScaleY(head_len / (size.height === 0 ? 100 : size.width))
        if (noneMask){
            let node = cc.Node.create()
            node.width = head_len
            node.height = head_len 
            node.addChild(sprite)
            return node
        }else{
            let  clipping = cc.ClippingNode.create()
            // 得设置 ClippingNode 的高宽，不然会导致其出不来
            clipping.width = head_len
            clipping.height = head_len 
            // let 设置蒙版
            var circleTemplete = cc.Sprite.createWithSpriteFrameName("uilibrary/friendboard_head.png");
            circleTemplete.setScale(0.8)
            clipping.setStencil(circleTemplete)
            clipping.addChild(sprite)
            return clipping
        }
    } else {
        FrameLoader.loadImageWithPlist("materials/head_images.plist")
        return cc.Sprite.createWithSpriteFrameName("h10")
    }
}
HeadImageLoader.replaceImage = function (node, sprite) {
    if (!node.nodeExist) {
        return false
    }
    var size = node.getContentSize()
    var name_node = node.getName()
    var z_order = node.getLocalZOrder()
    var arrivalOrder = node.getOrderOfArrival()
    var [scaleX, scaleY] = [node.getScaleX(), node.getScaleY()]
    var sSize = sprite.getContentSize()
    sprite.setScaleX((size.width * scaleX) / sSize.width)
    sprite.setScaleY((size.height * scaleY) / sSize.height)
    sprite.setPosition(cc.p(node.getPosition()))
    sprite.setName(node.getName());
    sprite.setOpacity(node.getOpacity());
    sprite.setCascadeOpacityEnabled(node.isCascadeOpacityEnabled());
    let hasParent = true;
    if (node.getParent()) {        
        node.getParent().addChild(sprite)
        if (name_node) {
            sprite.setName(name_node)
        }
        node.removeFromParent(true)
    } else {
        hasParent = false;
    }
    sprite.setLocalZOrder(z_order)
    sprite.setOrderOfArrival(arrivalOrder)
    return hasParent;
}
